import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 300px;
    margin: 20px;
    box-shadow: 0 1px 1px rgb(0 0 0 / 11%), 0 2px 2px rgb(0 0 0 / 11%), 0 4px 4px rgb(0 0 0 / 11%);
    transition: 0.2s;
    &:hover {
        transform: translate(0, -4px);
    }
`;

const StyledLink = styled(Link)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    text-decoration: none;
`;

const ImageContainer = styled.div`
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
`;

const Image = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
`;

const TextContainer = styled.div`
    padding: 15px;
    text-align: center;
    background: #f2f3f4;
    width: 100%;
    height: 50%;
`;

const Title = styled.h6`
    color: #B51F2B;
    font-weight: bold;
    margin: 0 0 10px 0;
    font-size: 18px;
`;

const Description = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555555;
`;

export default function ImageWithText({ src, title, description, link }) {
    return (
        <Container>
            <StyledLink to={link}>
                <ImageContainer>
                    <Image src={src} alt={title} />
                </ImageContainer>
                <TextContainer>
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                </TextContainer>
            </StyledLink>
        </Container>
    );
}